import React from 'react'
import PropTypes from 'prop-types'
import { CheckOutlined } from '@ant-design/icons'
import { Button } from './styled'

export const SelectButton = ({ selected, onClick, size = 20 }) => (
  <Button className="item-selector" selected={selected} onClick={onClick} size={size}>
    <div className="circle">
      {selected && <CheckOutlined />}
    </div>
  </Button>
)

SelectButton.propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  size: PropTypes.number
}
